import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  StripeConfigurationControl,
  StripeConfigurationFormValues,
} from '../../StripeConfigurationFormSchema';
import { SYNC_PAYMENT_REF_OPTIONS } from './constants';

type PaymentRefConfigurationSectionProps = {
  control: StripeConfigurationControl;
  defaultValues: StripeConfigurationFormValues;
};

export const PaymentRefConfigurationSection: FC<PaymentRefConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Payments">
    <Controller
      name="syncPaymentRefIdToErp"
      control={control}
      defaultValue={defaultValues.syncPaymentRefIdToErp}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to sync payment reference ID to ERP"
          value={getFlagFromStatus(value)}
          onChange={(selected) => onChange(getStatusByFlag(selected))}
          keyExtractor={(option) => option.value}
          options={SYNC_PAYMENT_REF_OPTIONS}
        />
      )}
    />
  </ConfigurationSection>
);
